/**
 * Suma los montos de un listado solo si tienen la misma unidad
 * @param {Array<{total: number, unit: string}>} listado
 * @param {string} targetUnit - unidad a la que queremos sumar (ej: "USD", "kWh")
 * @returns {{total: number, invalid: Array}} total y elementos inválidos
 */
export function sumSameUnit(listado, targetUnit) {
  let totalSum = 0;
  const invalid = [];

  listado.forEach(item => {
    const { total, unit } = item;

    if (typeof total !== "number" || isNaN(total) || total <= 0) {
      invalid.push(item);
      return;
    }

    // if (unit !== targetUnit) {
    //   invalid.push(item);
    //   return;
    // }

    totalSum += total;
  });

  return { total:totalSum, invalid };
}
